import metamaskIcon from '@ui/assets/metamask.svg';
import { injected } from 'wagmi/connectors';

import {
  findMetaMaskProvider,
  isMetaMaskInstalled,
} from '../utils/findInjectedProvider';

export const metamaskConnector = () => {
    const c = injected({
        target: {
            id: 'io.metamask',
            name: 'MetaMask',
            // Use EIP-6963 to find the real MetaMask provider, instead of
            // blindly trusting `window.ethereum.isMetaMask` (which other
            // wallets like Phantom / Bitget / Brave / TokenPocket fake).
            // @ts-ignore
            provider: () => findMetaMaskProvider(),
        },
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);
        
return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'io.metamask',
            name: 'MetaMask',
            icon: metamaskIcon.src,
            getWalletConnectDeeplink: null,
            getQrCode: () => null,
            // @ts-ignore
            isAuthorized: async () => {
                if (!isMetaMaskInstalled()) {
                    return false;
                }
                
return connector.isAuthorized();
            },
            get installed() {
                return isMetaMaskInstalled();
            },
            get suggested() {
                return true;
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://metamask.io/download/',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                        return 'https://metamask.io/download/';
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );
                    if (isMobile) {
                        return `https://metamask.app.link/dapp/${window.location.host}${window.location.pathname}`;
                    }
                    
return 'https://metamask.io/download/';
                },
            },
        };
    };
};
